export default (string = '') => {
  if (string === null) {
    return null;
  }
  return string.replace(/[^0-9]+/g, '');
};
